//
// Touch Area Manager
//
// Used by ResourceManager to create touch areas

touchAreaManager = {};
touchAreaManager.touchAreas = [];

touchAreaManager.createTouchArea = function (json) {
  var touchArea = new PIXI.Sprite(PIXI.Texture.EMPTY);
  touchArea.Props = {};
  touchArea.width = Number(json.width);
  touchArea.height = Number(json.height);
  touchArea.anchor.x = 0.5;
  touchArea.anchor.y = 0.5;

  touchArea.setCallback = function (callback) {
    touchArea.interactive = true;
    touchArea.mousedown = touchArea.touchstart = callback;
  };

  touchArea.clearCallback = function () {
    touchArea.interactive = false;
    touchArea.mousedown = touchArea.touchstart = undefined;
  };

  touchAreaManager.touchAreas.push(touchArea);
  touchArea.clearCallback();
  return touchArea;
};
touchAreaManager.destroyTouchArea = function (touchArea) {
  var index = touchAreaManager.touchAreas.indexOf(touchArea);
  if (index === -1) {
    console.log("Could not destroy animation strip as it could not be found");
    return;
  }

  touchAreaManager.touchAreas.splice(index, 1);
};

touchAreaManager.initialiseTouchArea = function (json) {};

resourceManager.registerObjectType(
  "touchArea",
  touchAreaManager.createTouchArea,
  touchAreaManager.initialiseTouchArea,
  function () {
    return [];
  },
  touchAreaManager.destroyTouchArea
);
